import {
  setEnrichmentData,
  setEnrichmentError,
  setEnrichmentFile,
  setEnrichmentSheetName,
} from 'actions/enrichmentWizard';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useReadFile = file => {
  const dispatch = useDispatch();

  const handleRemoveFile = useCallback(() => {
    dispatch(setEnrichmentFile(null));
    dispatch(setEnrichmentData([]));
    dispatch(setEnrichmentError(null));
  }, [dispatch]);

  useEffect(() => {
    const reader = new FileReader();
    const worker = new Worker(
      new URL('../../Workers/uploadWorker.js', import.meta.url)
    );

    reader.onload = e => {
      worker.postMessage({
        arrayBuffer: e.target.result,
        fileType: file.type,
        fileName: file.name,
      });
    };

    worker.onmessage = e => {
      if (e.data.status === 'success') {
        const rows = e.data.data.length;
        if (rows === 0) {
          dispatch(setEnrichmentError('Your file is empty'));
          dispatch(setEnrichmentFile(null));
          dispatch(setEnrichmentData([]));
          return;
        }

        if (rows > 5001) {
          dispatch(
            setEnrichmentError(
              'Your file exceeds our 5,000 row limit. Please upload a file with fewer rows.'
            )
          );
          dispatch(setEnrichmentFile(null));
          dispatch(setEnrichmentData([]));
          return;
        }
        dispatch(setEnrichmentData(e.data.data));
        dispatch(setEnrichmentSheetName(e.data.firstSheetName));
      } else {
        dispatch(setEnrichmentError('Error reading file'));
        dispatch(setEnrichmentFile(null));
        dispatch(setEnrichmentData([]));
      }
      worker.terminate();
    };

    if (file) {
      reader.readAsArrayBuffer(file);
    }

    return () => {
      worker.terminate();
    };
  }, [file, dispatch, handleRemoveFile]);
};
